<template>
  <div id="swimlanesDiv" style="overflow: auto">
    <div :id="'hierCol' + officeIndex" class="col hierCol">
      <draggable
        :group="group"
        handle=".drag-item"
        @start="dragStart"
        @end="dragEnd"
        :scroll-sensitivity="100"
        :scroll="true"
        :bubble-scroll="true"
        :delay="200"
        :delay-on-touch-only="true"
      >
        <v-card
          :min-width="calcWidth"
          :max-height="calcHeight"
          class="elevation-7"
        >
          <v-row no-gutters>
            <v-col>
              <template v-for="connector of connectors">
                <template v-if="connector.div && connector.div.lineId">
                  <v-tooltip
                    right
                    :key="connector.id"
                    color="#00558C"
                    dark
                    z-index="999"
                  >
                    <template v-slot:activator="{ on }">
                      <div
                        :id="connector.div.lineId"
                        :ref="connector.div.lineId"
                        class="muConnector connectorDiv"
                        :style="connector.lineStyle"
                        :key="connector.id.toString()"
                        v-on="on"
                      ></div>
                    </template>
                    <span>
                      {{ connector.from }}&nbsp;
                      <v-icon color="white">mdi-arrow-right</v-icon>
                      &nbsp;{{ connector.to }}
                    </span>
                  </v-tooltip>
                </template>
              </template>

              <v-row
                v-for="(level, index) of sortedLevels"
                :key="index"
                class="hierRow"
                :style="'background-color: ' + level.levelColor + ';'"
              >
                <v-col
                  style="max-width: 200px !important; padding: 0; margin: 0"
                >
                  <span style="font-size: 0.8rem">
                    <strong>{{ level.levelName }}</strong>

                    <v-tooltip right color="#00558C" z-index="999">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="#00558C"
                          size="20"
                          v-on="on"
                          style="margin-left: 10px"
                          >mdi-information-outline</v-icon
                        >
                      </template>
                      <span>
                        {{ level.description }}
                        <br />
                        <ul>
                          <li
                            v-for="detail in level.descriptionDetails"
                            :key="detail"
                          >
                            {{ detail }}
                          </li>
                        </ul>
                      </span>
                    </v-tooltip>
                  </span>
                </v-col>

                <v-col style="white-space: nowrap">
                  <!-- Agents -->

                  <v-layout
                    class="agentWrapper"
                    justify-center
                    row
                    v-if="level.levelOrder == agentLevel"
                  >
                    <div
                      class="agentDiv"
                      v-for="(membersByParent, index) in level.membersByParent"
                      :key="index"
                      :style="
                        findOffset(
                          level.levelOrder,
                          level.membersByParent.length
                        )
                      "
                    >
                      <v-layout column>
                        <div
                          v-for="(member,
                          index) in membersByParent.levelMembers"
                          :key="index"
                          :id="buildRef(member)"
                          :ref="buildRef(member)"
                          class="thing nameDiv drop-zone agentsDiv"
                          :style="
                            'margin-left: 5px;border: 2px solid ' +
                              connectorColors[level.levelOrder] +
                              ';'
                          "
                        >
                          <draggable
                            :group="group"
                            handle=".drag-item"
                            @start="dragStart"
                            @end="dragEnd"
                            :scroll-sensitivity="100"
                            :scroll="true"
                            :bubble-scroll="true"
                            :delay="200"
                            :delay-on-touch-only="true"
                          >
                            <div
                              :draggable="true"
                              :class="
                                editableFlag
                                  ? 'drag-item row align-center align-content-center justify-center thing'
                                  : 'row align-center align-content-center justify-center thing'
                              "
                              :id="'_' + member.id"
                              :style="
                                isRevoked(member.id)
                                  ? 'color:red'
                                  : (member.terminationDate &&
                                      member.terminationDate) != ''
                                  ? 'color:orange;font-weight:bold;'
                                  : member.newFlag
                                  ? 'color:green'
                                  : ''
                              "
                            >
                              <span style="padding-right: 10px"></span>
                              {{ member.name }}
                              <span style="padding-right: 10px"></span>

                              <!-- <template v-if="editableFlag">
                                <v-tooltip top color="#00558c">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-on="on"
                                      size="25"
                                      style="margin-right: 4px"
                                      @click.stop="moveMember(member)"
                                      >mdi-account-switch</v-icon
                                    >
                                  </template>
                                  <span>Move Agent</span>
                                </v-tooltip>

                                <v-tooltip top color="#00558C">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      size="25"
                                      style="margin-right: 4px"
                                      v-on="on"
                                      @click.stop="
                                        if (editableFlag)
                                          checkForDelete(member);
                                      "
                                      >mdi-delete</v-icon
                                    >
                                  </template>
                                  <span
                                    >Remove From Hierarchy or Revoke
                                    Access</span
                                  >
                                </v-tooltip>
                              </template> -->

                              <!-- editableFlag -->
                              <!-- <v-tooltip top color="#00558C">
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    @click.stop="getDetails(member, level)"
                                    size="25"
                                    style="margin-right: 4px"
                                    v-on="on"
                                    :color="
                                      member.newFlag == true
                                        ? 'green'
                                        : 'initial'
                                    "
                                    >mdi-account</v-icon
                                  >
                                </template>
                                <span v-if="member.newFlag == true">New!</span>
                                <span v-else>Details</span>
                              </v-tooltip> -->
                              <!-- 
                              <template v-if="editableFlag">
                                <v-tooltip top color="#00558C">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      size="25"
                                      style="margin-right: 4px"
                                      v-on="on"
                                      @click.stop="
                                        if (editableFlag)
                                          replacePosition(member, level);
                                      "
                                      >mdi-account-convert</v-icon
                                    >
                                  </template>
                                  <span>Replace Position In Hierarchy</span>
                                </v-tooltip>

                                <v-tooltip
                                  top
                                  color="#00558c"
                                  v-if="isRevoked(member.id)"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-on="on"
                                      size="25"
                                      style="margin-right: 4px"
                                      color="red"
                                      @click.stop="restoreUserAccess(member)"
                                      >mdi-alert</v-icon
                                    >
                                  </template>
                                  <span
                                    >SalesForce Access Has Been Revoked</span
                                  >
                                </v-tooltip> 
                              </template> -->

                              <div v-if="editableFlag">
                                <v-tooltip
                                  top
                                  color="#00558c"
                                  v-if="level.levelOrder > 1"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-on="on"
                                      size="25"
                                      style="margin-right: 4px"
                                      @click.stop="moveMember(member)"
                                      >mdi-account-switch</v-icon
                                    >
                                  </template>
                                  <span>Move Agent</span>
                                </v-tooltip>
                              </div>
                              <div
                                v-if="
                                  editableFlag &&
                                    (level.levelOrder > 0 ||
                                      !isRevoked(member.id)) &&
                                    member.name != 'Home Office'
                                "
                              >
                                <v-tooltip top color="#00558C">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-on="on"
                                      @click.stop="
                                        checkForRevokeOrDelete(
                                          editableFlag,
                                          level.levelOrder,
                                          member
                                        )
                                      "
                                      size="25"
                                      style="margin-right: 4px"
                                      >mdi-delete</v-icon
                                    >
                                  </template>
                                  <span v-if="level.levelOrder > 0"
                                    >Remove From Hierarchy or Revoke
                                    Access</span
                                  >
                                  <span v-else>Revoke AO's Access</span>
                                </v-tooltip>
                              </div>

                              <!-- editableFlag -->

                              <div v-if="isABL(member.id)">
                                <v-tooltip top color="#00558C">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      @click.stop="getDetails(member, level)"
                                      v-on="on"
                                      size="25"
                                      style="margin-right: 4px"
                                      :color="
                                        member.newFlag == true
                                          ? 'green'
                                          : '#4682b4'
                                      "
                                      >mdi-account-star</v-icon
                                    >
                                  </template>
                                  <span v-if="member.newFlag == true"
                                    >New!</span
                                  >
                                  <span v-else>Details</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <v-tooltip top color="#00558C">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      @click.stop="getDetails(member, level)"
                                      v-on="on"
                                      size="25"
                                      style="margin-right: 4px"
                                      :color="
                                        member.newFlag == true
                                          ? 'green'
                                          : 'initial'
                                      "
                                      >mdi-account</v-icon
                                    >
                                  </template>
                                  <span v-if="member.newFlag == true"
                                    >New!</span
                                  >
                                  <span v-else>Details</span>
                                </v-tooltip>
                              </div>

                              <div
                                v-if="
                                  (editableFlag && level.levelOrder > 1) ||
                                    (editableFlag &&
                                      level.levelOrder == 1 &&
                                      isHomeOfficeUser)
                                "
                              >
                                <v-tooltip top color="#00558C">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-on="on"
                                      @click.stop="
                                        if (editableFlag)
                                          replacePosition(member, level);
                                      "
                                      size="25"
                                      style="margin-right: 4px"
                                      >mdi-account-convert</v-icon
                                    >
                                  </template>
                                  <span>Replace Position In Hierarchy</span>
                                </v-tooltip>
                              </div>

                              <div
                                v-if="
                                  editableFlag &&
                                    level.levelOrder == 2 &&
                                    !isABL(member.id)
                                "
                              >
                                <v-tooltip top color="#00558C">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-on="on"
                                      @click.stop="
                                        createOffice(
                                          member,
                                          member.parentId,
                                          level
                                        )
                                      "
                                      size="25"
                                      style="margin-right: 4px"
                                      >mdi-home-plus</v-icon
                                    >
                                  </template>
                                  <span>Create New Office</span>
                                </v-tooltip>
                              </div>
                              <div v-if="editableFlag && isRevoked(member.id)">
                                <v-tooltip top color="#00558c">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-on="on"
                                      size="25"
                                      style="margin-right: 4px"
                                      color="red"
                                      @click.stop="restoreUserAccess(member)"
                                      >mdi-alert</v-icon
                                    >
                                  </template>
                                  <span
                                    >SalesForce Access Has Been Revoked</span
                                  >
                                </v-tooltip>
                              </div>
                            </div>
                          </draggable>
                        </div>
                      </v-layout>
                    </div>
                  </v-layout>

                  <!-- Non-agents -->

                  <v-layout
                    row
                    align-center
                    align-content-center
                    justify-center
                    v-if="level.levelOrder < agentLevel"
                  >
                    <div
                      v-for="(member, index) in level.levelMembers"
                      :key="index"
                      :id="buildRef(member)"
                      :ref="buildRef(member)"
                      class="thing nameDiv drop-zone"
                      :style="
                        'border: 2px solid ' +
                          connectorColors[level.levelOrder] +
                          ';' +
                          findOffset(
                            level.levelOrder,
                            level.levelMembers.length
                          )
                      "
                    >
                      <draggable
                        :group="group"
                        handle=".drag-item"
                        @start="dragStart"
                        @end="dragEnd"
                        :scroll-sensitivity="100"
                        :scroll="true"
                        :bubble-scroll="true"
                        :delay="200"
                        :delay-on-touch-only="true"
                      >
                        <div
                          :draggable="true"
                          :class="
                            editableFlag
                              ? 'drag-item row align-center align-content-center justify-center thing'
                              : 'row align-center align-content-center justify-center thing'
                          "
                          :id="'_' + member.id"
                          :style="
                            isRevoked(member.id)
                              ? 'color:red'
                              : (member.terminationDate &&
                                  member.terminationDate) != ''
                              ? 'color:orange;font-weight: bold;'
                              : member.newFlag
                              ? 'color:green'
                              : ''
                          "
                        >
                          <span style="padding-right: 10px"></span>
                          {{ member.name }}
                          <span style="padding-right: 10px"></span>

                          <div v-if="editableFlag">
                            <v-tooltip
                              top
                              color="#00558c"
                              v-if="level.levelOrder > 1"
                            >
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  size="25"
                                  style="margin-right: 4px"
                                  @click.stop="moveMember(member)"
                                  >mdi-account-switch</v-icon
                                >
                              </template>
                              <span>Move Agent</span>
                            </v-tooltip>
                          </div>
                          <div
                            v-if="
                              editableFlag &&
                                (level.levelOrder > 0 ||
                                  (!isRevoked(member.id) &&
                                    isHomeOfficeUser)) &&
                                member.name != 'Home Office'
                            "
                          >
                            <v-tooltip top color="#00558C">
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-if="
                                    level.levelOrder > 1 || isHomeOfficeUser
                                  "
                                  v-on="on"
                                  @click.stop="
                                    checkForRevokeOrDelete(
                                      editableFlag,
                                      level.levelOrder,
                                      member
                                    )
                                  "
                                  size="25"
                                  style="margin-right: 4px"
                                  >mdi-delete</v-icon
                                >
                              </template>
                              <span v-if="level.levelOrder > 1">
                                Remove From Hierarchy or Revoke Access
                              </span>
                              <span
                                v-else-if="
                                  level.levelOrder == 1 && isHomeOfficeUser
                                "
                              >
                                Remove From Hierarchy or Revoke Access
                              </span>
                              <span v-else-if="isHomeOfficeUser">
                                Revoke AO's Access
                              </span>
                            </v-tooltip>
                          </div>

                          <!-- editableFlag -->

                          <div v-if="isABL(member.id)">
                            <v-tooltip top color="#00558C">
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  @click.stop="getDetails(member, level)"
                                  v-on="on"
                                  size="25"
                                  style="margin-right: 4px"
                                  :color="
                                    member.newFlag == true ? 'green' : '#4682b4'
                                  "
                                  >mdi-account-star</v-icon
                                >
                              </template>
                              <span v-if="member.newFlag == true">New!</span>
                              <span v-else>Details</span>
                            </v-tooltip>
                          </div>
                          <div v-else>
                            <v-tooltip top color="#00558C">
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  @click.stop="getDetails(member, level)"
                                  v-on="on"
                                  size="25"
                                  style="margin-right: 4px"
                                  :color="
                                    member.newFlag == true ? 'green' : 'initial'
                                  "
                                  >mdi-account</v-icon
                                >
                              </template>
                              <span v-if="member.newFlag == true">New!</span>
                              <span v-else>Details</span>
                            </v-tooltip>
                          </div>

                          <div
                            v-if="
                              (editableFlag && level.levelOrder > 1) ||
                                (editableFlag &&
                                  level.levelOrder == 1 &&
                                  isHomeOfficeUser)
                            "
                          >
                            <v-tooltip top color="#00558C">
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  @click.stop="
                                    if (editableFlag)
                                      replacePosition(member, level);
                                  "
                                  size="25"
                                  style="margin-right: 4px"
                                  >mdi-account-convert</v-icon
                                >
                              </template>
                              <span>Replace Position In Hierarchy</span>
                            </v-tooltip>
                          </div>

                          <div
                            v-if="
                              editableFlag &&
                                level.levelOrder == 2 &&
                                !isABL(member.id)
                            "
                          >
                            <v-tooltip top color="#00558C">
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  @click.stop="
                                    createOffice(member, member.parentId, level)
                                  "
                                  size="25"
                                  style="margin-right: 4px"
                                  >mdi-home-plus</v-icon
                                >
                              </template>
                              <span>Create New Office</span>
                            </v-tooltip>
                          </div>
                          <div v-if="editableFlag && isRevoked(member.id)">
                            <v-tooltip top color="#00558c">
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  size="25"
                                  style="margin-right: 4px"
                                  color="red"
                                  @click.stop="restoreUserAccess(member)"
                                  >mdi-alert</v-icon
                                >
                              </template>
                              <span>SalesForce Access Has Been Revoked</span>
                            </v-tooltip>
                          </div>
                          <!-- editableFlag -->
                        </div>
                      </draggable>
                    </div>
                  </v-layout>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </draggable>
    </div>
  </div>
</template>

<script>
import EventBus from "@/eventBus.js";
import { Sortable, AutoScroll } from "sortablejs/modular/sortable.core.esm.js";
import utilityMixins from "@/utility-mixins.js";
import $j from "jquery";
Sortable.mount(new AutoScroll());

import draggable from "vuedraggable";

export default {
  mixins: [utilityMixins],
  props: {
    editableFlag: Boolean,
    moveHierFlag: Boolean,
    connectorColors: Array,
    agentLevel: Number,
    abLevel: Number,
    ablLevel: Number,
    officeIndex: Number,
    aoRevokedFlag: Boolean,
    scrollToMember: Object,
    highlightMember: Object
  },

  components: {
    draggable
  },
  created() {
    try {
      this.aoRevoked = this.aoRevokedFlag;

      let users = [];

      for (let level of this.sortedLevels) {
        for (let member of level.levelMembers) {
          users.push({
            level: level.levelOrder,
            member: member
          });
        }
      }

      for (let hier of this.levelReports) {
        let parent = users.find(u => u.member.id == hier.parentId);
        let child = users.find(u => u.member.id == hier.childId);

        this.addConnector(
          { level: parent.levelOrder, member: parent.member },
          { level: child.levelOrder, member: child.member }
        );
      }

      this.$nextTick(function() {
        this.handleAgentConnectors();
      });
    } catch (e) {
      this.addToErrorLogs("swimlanes-component created", e);
    }
  },
  directives: {},
  beforeDestroy() {
    EventBus.$off("recalculateConnectors");
    EventBus.$off("addConnector");
    EventBus.$off("handleAgentConnectors");
    EventBus.$off("checkConnectors");
    EventBus.$off("agentPool");
    EventBus.$off("levelReports");
    EventBus.$off("levels");
    EventBus.$off("indexChange");
    EventBus.$off("clearConnectors");
    EventBus.$off("removeParentConnectors");
    EventBus.$off("changeConnectorParent");
    EventBus.$off("removeConnectors");
    EventBus.$off("setAORevokedStatus");
    EventBus.$off("bulkMoveInProgress");
    EventBus.$off("editPushed");
  },
  mounted() {
    try {
      EventBus.$on(
        "bulkMoveInProgress",
        function(bulkMove) {
          this.bulkMoveInProgress = bulkMove;
          if (this.bulkMoveInProgress == false) {
            this.removeOrphans();
          }
        }.bind(this)
      );

      EventBus.$on(
        "editPushed",
        function(currentIndex) {
          if (this.officeIndex == currentIndex) {
            this.editPushed = true;
            console.log("edit pushed");
          }
        }.bind(this)
      );

      EventBus.$on(
        "setAORevokedStatus",
        function(flag) {
          this.aoRevoked = flag;
        }.bind(this)
      );

      EventBus.$on(
        "removeConnectors",
        function(node, currentIndex) {
          if (this.officeIndex != currentIndex) return;

          this.removeConnectors(node);
        }.bind(this)
      );

      EventBus.$on(
        "clearConnectors",
        function(currentIndex) {
          if (this.officeIndex != currentIndex) return;

          this.connectors.splice(0);
        }.bind(this)
      );

      EventBus.$on(
        "removeParentConnectors",
        function(node, currentIndex) {
          if (this.officeIndex != currentIndex) return;

          let remArray = [];
          for (let connector of this.connectors) {
            if (connector.ele2ref == this.buildRef(node)) {
              remArray.push(connector);
            }
          }

          for (let rem of remArray) {
            let idx = this.connectors.findIndex(c => c.id == rem.id);
            if (idx >= 0) this.connectors.splice(idx, 1);
          }
        }.bind(this)
      );

      EventBus.$on(
        "indexChange",
        function(levelReports, levels, agentPool, revokedAgents, currentIndex) {
          try {
            if (!this) return;

            if (this.officeIndex != currentIndex) return;

            this.levelReports = [];
            this.levelReports.push(...levelReports);

            this.levels = [];
            this.levels.push(...levels);

            this.agentPool = [];
            this.agentPool.push(...agentPool);

            this.revokedAgents = [];
            this.revokedAgents.push(...revokedAgents);

            if (this.highlightMember) {
              this.$nextTick().then(() => {
                let searchRef = this.buildRef(this.highlightMember);
                if (
                  searchRef &&
                  this.$refs[searchRef] &&
                  this.$refs[searchRef][0]
                ) {
                  let elRef = this.$refs[searchRef][0].firstElementChild;
                  $j("div").removeClass("highlight");
                  elRef.classList.add("highlight");
                }
              });
            }
          } catch (e) {
            this.addToErrorLogs("swimlanes-component $on indexChange", e);
          }
          // this.checkConnectors();
        }.bind(this)
      );

      EventBus.$on(
        "agentPool",
        function(ap, currentIndex) {
          if (this.officeIndex != currentIndex) return;

          this.agentPool = [];
          this.agentPool.push(...ap);
        }.bind(this)
      );

      EventBus.$on(
        "levelReports",
        function(lr, currentIndex) {
          if (this.officeIndex != currentIndex) return;

          this.levelReports = [];
          this.levelReports.push(...lr);
        }.bind(this)
      );

      EventBus.$on(
        "levels",
        function(l, currentIndex) {
          if (this.officeIndex != currentIndex) return;

          this.levels = [];
          this.levels.push(...l);
        }.bind(this)
      );

      EventBus.$on(
        "checkConnectors",
        function(currentIndex) {
          if (this.officeIndex != currentIndex) return;
          this.checkConnectors();
        }.bind(this)
      );

      EventBus.$on(
        "handleAgentConnectors",
        function(currentIndex) {
          if (this.officeIndex != currentIndex) return;
          this.handleAgentConnectors();
        }.bind(this)
      );

      EventBus.$on(
        "addConnector",
        function(parent, child, currentIndex) {
          if (this.officeIndex != currentIndex) return;
          this.addConnector(parent, child);
        }.bind(this)
      );

      EventBus.$on(
        "recalculateConnectors",
        function(currentIndex) {
          this.cardHeight = window.innerHeight - 250;
          if (this.officeIndex != currentIndex) return;
          this.recalc();
        }.bind(this)
      );

      EventBus.$on(
        "changeConnectorParent",
        function(node, newParent, currentIndex) {
          if (this.officeIndex != currentIndex) return;
          for (let connector of this.connectors) {
            if (connector.ele2ref == this.buildRef(node)) {
              connector.ele1ref = this.buildRef(newParent);
              connector.from = newParent.name;
            }
          }
        }.bind(this)
      );
    } catch (e) {
      this.addToErrorLogs("swimlanes-component mounted", e);
    }

    console.log("mOunted");
  },
  updated() {
    if (this.editPushed) {
      this.editPushed = false;
      let self = this;
      this.recalcTimer = setInterval(function() {
        clearInterval(this.recalcTimer);
        self.recalculateConnectors();
      }, 1000); // 1 second
    }
  },
  computed: {
    ABLevelMembers() {
      for (let level of this.levels) {
        if (level.levelOrder == this.ablLevel) {
          return level.levelMembers;
        }
      }

      return [];
    },
    calcWidth() {
      try {
        let max = 0;

        for (let level of this.sortedLevels) {
          if (level.levelOrder < this.agentLevel) {
            if (level.levelMembers.length > max)
              max = level.levelMembers.length;
          } else {
            if (level.membersByParent.length > max) {
              max = level.membersByParent.length;
            }
          }
        }

        let calculated = 150 + max * 350;

        return calculated > window.innerWidth * 0.8
          ? calculated
          : window.innerWidth * 0.8;
      } catch (e) {
        this.addToErrorLogs("swimlanes-component calcWidth", e);
        return 0;
      }
    },

    calcHeight() {
      return this.cardHeight > window.innerHeight * 0.8
        ? this.cardHeight
        : window.innerHeight * 0.8 > 450
        ? window.innerHeight * 0.8
        : 450;
    },

    sortedLevels() {
      try {
        let sortedParents = [];
        let ret = [];

        for (let level of this.levels) {
          if (level.levelOrder == this.ablLevel) continue;

          let revisedParents = [];

          let node = {
            levelColor: level.levelColor,
            levelOrder: level.levelOrder,
            levelName: level.levelName,
            description: level.description,
            descriptionDetails: level.descriptionDetails,
            levelMembers: [],
            membersByParent: []
          };

          if (level.levelOrder == 0) {
            node.levelMembers.push(...level.levelMembers);
            sortedParents = node.levelMembers;
          } else {
            revisedParents.push(...sortedParents);

            for (let parent of sortedParents) {
              let subArray = [];
              // revisedParents.push(parent);

              for (let member of level.levelMembers) {
                if (member.parentId == parent.id) {
                  subArray.push(member);
                }
              }

              if (level.levelOrder == this.abLevel) {
                for (let level of this.levels) {
                  if (level.levelOrder == this.ablLevel) {
                    for (let member of level.levelMembers) {
                      if (member.parentId == parent.id) {
                        subArray.push(member);
                      }
                    }
                  }
                }
              }

              if (subArray.length) {
                subArray = this.sortByName(subArray, "name");
                revisedParents.push(...subArray);
                node.levelMembers.push(...subArray);

                node.membersByParent.push({
                  parentId: parent.id,
                  levelMembers: subArray
                });
              }
            }

            sortedParents = revisedParents; // this.sortByName(revisedParents, "name");
          }

          ret.push(node);
        }

        return ret;
      } catch (e) {
        this.addToErrorLogs("swimlanes-component sortedLevels", e);
        return [];
      }
    }
  },
  watch: {
    highlightMember: {
      handler() {
        $j("div").removeClass("highlight");

        if (!this.highlightMember || !this.highlightMember.id) return;

        this.$nextTick().then(() => {
          let searchRef = this.buildRef(this.highlightMember);
          if (searchRef && this.$refs[searchRef] && this.$refs[searchRef][0]) {
            let elRef = this.$refs[searchRef][0].firstElementChild;
            elRef.classList.add("highlight");
          }
        });
      },
      deep: true
    },
    scrollToMember: {
      handler() {
        if (!this.scrollToMember || !this.scrollToMember.id) return;

        this.$nextTick().then(() => {
          let searchRef = this.buildRef(this.scrollToMember);
          if (searchRef && this.$refs[searchRef] && this.$refs[searchRef][0]) {
            let elRef = this.$refs[searchRef][0].firstElementChild;
            var offsetTop = elRef.offsetTop;
            var adjustment = Math.max(
              0,
              ($j("#hierCol" + this.officeIndex).height() -
                elRef.offsetHeight) /
                2
            );

            var scrollTop = offsetTop - adjustment;

            var offsetSide = elRef.offsetLeft;
            var adj = Math.max(
              0,
              ($j("#swimlanesDiv").width() - elRef.offsetWidth) / 2
            );
            var scrollHorizontal = offsetSide - adj;

            $j("#hierCol" + this.officeIndex).animate(
              {
                scrollTop: scrollTop,
                scrollLeft: scrollHorizontal
              },
              1000
            );

            elRef.classList.add("highlight");
            // $j("#swimlanesDiv").animate({ scrollLeft: 600 }, 1000);
          }
        });
      },
      deep: true
    },
    sortedLevels() {
      try {
        if (this.bulkMoveInProgress == true) return;

        this.$nextTick(function() {
          this.handleAgentConnectors();
          this.removeOrphanConnectors();
        });
      } catch (e) {
        this.addToErrorLogs("swimlanes-component watch sortedLevels", e);
      }
    }
  },
  data() {
    return {
      recalcTimer: null,
      editPushed: false,
      bulkMoveInProgress: false,
      group: {
        name: "agents",
        pull: false,
        put: false
      },
      group2: {
        name: "reposition",
        pull: true,
        put: true
      },
      doNothing: false,
      moveEl: null,
      moveStartX: null,
      connectors: [],
      agentPool: [],
      revokedAgents: [],
      levelReports: [],
      levels: [],
      cardHeight: window.innerHeight - 100,
      aoRevoked: false
    };
  },
  methods: {
    checkForRevokeOrDelete(editableFlag, levelOrder, member) {
      if (editableFlag && levelOrder > 0) this.checkForDelete(member);
      else this.checkForRevoke(member);
    },
    restoreUserAccess(member) {
      EventBus.$emit("restoreMemberAccess", member);
    },
    isABL(id) {
      return this.ABLevelMembers.findIndex(ablm => ablm.id == id) >= 0;
    },
    isRevoked(id) {
      try {
        if (this.revokedAgents.findIndex(ra => ra.id == id) >= 0) {
          return true;
        }

        return false;
      } catch (e) {
        this.addToErrorLogs("swimlanes-component isRevoked", e);
        return false;
      }
    },

    // Find the node in the hierarchy based on its id
    findInHierarchy(id) {
      try {
        for (let level of this.levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == id) {
              return mem;
            }
          }
        }
        return null;
      } catch (e) {
        this.addToErrorLogs("swimlanes-component findInHierarchy", e);
        return null;
      }
    },
    checkConnectors() {
      try {
        this.removeOrphans();

        for (let levRep of this.levelReports) {
          let child = this.findInHierarchy(levRep.childId);
          let parent = this.findInHierarchy(levRep.parentId);

          if (child && parent) {
            let childRef = this.buildRef(child);
            let parentRef = this.buildRef(parent);

            let found = false;

            for (let connector of this.connectors) {
              if (
                connector.ele1ref == parentRef &&
                connector.ele2ref == childRef
              ) {
                found = true;
                break;
              }
            }

            if (!found && this.sortedLevels.length < this.agentLevel - 1) {
              let skipThis = false;

              for (let lev of this.sortedLevels) {
                if (lev.levelOrder == this.agentLevel) {
                  for (let parentLevel of lev.membersByParent) {
                    for (let mem of parentLevel.levelMembers) {
                      if (
                        mem.id == child.id &&
                        mem.id != parentLevel.levelMembers[0].id
                      ) {
                        skipThis = true;
                      }
                    }
                  }
                }
              }
              if (!skipThis) {
                let parentNodeLevel = this.findLevel(parent.id);
                let childNodeLevel = this.findLevel(child.id);

                this.addConnector(
                  { level: parentNodeLevel.levelOrder, member: parent },
                  { level: childNodeLevel.levelOrder, member: child }
                );
              }
            }
          }
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-component checkConnectors", e);
      }
    },

    findLevel(id) {
      try {
        for (let level of this.levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == id) {
              return level;
            }
          }
        }
        return null;
      } catch (e) {
        this.addToErrorLogs("swimlanes-component findLevel", e);
      }
    },
    createOffice(member, parentId, level) {
      EventBus.$emit("createOffice", member, parentId, level);
    },
    replacePosition(source, level) {
      // Called when clicking the swap icon on a non-AO node
      EventBus.$emit("replacePosition", source, level);
    },
    replaceAO(source, level) {
      // Called when clicking the swap icon on the AO node
      EventBus.$emit("replaceAO", source, level);
    },
    getDetails(member, level) {
      EventBus.$emit("getDetails", member, level);
    },
    checkForDelete(member) {
      EventBus.$emit("checkForDelete", member);
    },
    checkForRevoke(member) {
      EventBus.$emit("revokeAO", member);
    },
    moveMember(member) {
      EventBus.$emit("moveMember", member);
    },
    findOffset(levelOrder, numMembers) {
      try {
        let style = "";

        if (levelOrder == 0) return "";

        if (levelOrder % 2 == 0) style = "margin-left:";
        else style = "margin-right:";

        if (numMembers > 1) {
          let offset = 30 + levelOrder * 5;

          return style + offset.toString() + "px;";
        }

        let offset = levelOrder * 75 + levelOrder * 75;

        if (levelOrder > 3)
          offset = (levelOrder - 2) * 75 + (levelOrder - 2) * 75;

        if (levelOrder % 2 == 0) offset -= 100;
        else offset += 100;

        if (offset < 10) offset = 10;

        style += offset.toString() + "px;";

        return style;
      } catch (e) {
        this.addToErrorLogs("swimlanes-component findOffset", e);
        return "";
      }
    },
    removeOrphanConnectors() {
      try {
        this.removeOrphans();

        // and recalculate all the connector positions
        this.recalculateConnectors();
      } catch (e) {
        this.addToErrorLogs("swimlanes-component removeOrphanConnectors", e);
      }
    },
    removeOrphans() {
      try {
        // If there are any orphaned connectors where the parent or child is undefined, remove them.
        let hierUsers = [];

        // Collect all the hierarchy members into one array.
        for (let level of this.levels) hierUsers.push(...level.levelMembers);

        let orphans = [];

        for (let connector of this.connectors) {
          let ele1Idx = hierUsers.find(
            h => this.buildRef(h) === connector.ele1ref
          );
          let ele2Idx = hierUsers.find(
            h => this.buildRef(h) === connector.ele2ref
          );

          // if either the parent reference or the child reference doesn't have a corresponding node
          //  in the combined array, mark the connector for removal

          if (ele1Idx < 0 || ele2Idx < 0) orphans.push(connector);
        }

        // remove the marked connectors
        for (let orphan of orphans) {
          let idx = this.connectors.findIndex(
            c => c.ele1ref == orphan.ele1ref && c.ele2ref == orphan.ele2ref
          );
          if (idx >= 0) this.connectors.splice(idx, 1);
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-component removeOrphans", e);
      }
    },
    handleAgentConnectors() {
      try {
        // Remove extraneous connectors from the agent lists, which
        // are displayed in columns instead of rows
        let removeArray = [];

        if (this.sortedLevels.length == 0) return;

        for (let lev of this.sortedLevels) {
          if (lev.levelOrder == this.agentLevel) {
            for (let parentLevel of lev.membersByParent) {
              for (let mem of parentLevel.levelMembers) {
                let found = false;
                for (let connector of this.connectors) {
                  // if the connector belongs to the agents level (sortedLevels[4])
                  if (connector.ele2ref == this.buildRef(mem)) {
                    found = true;

                    // if the connector's associated node is NOT the first node in the subArray
                    // (in other words, not the first agent in the agent's column for this parent node)
                    // add its connector to the array of connectors to be removed.
                    if (mem.id != parentLevel.levelMembers[0].id) {
                      removeArray.push(connector);
                    }
                  }
                }

                // if a connector wasn't found for this node, and it IS the first node in the subarray
                // (first node in the displayed column)
                // add a connector for it.
                if (!found && mem.id == parentLevel.levelMembers[0].id) {
                  // collect all the users into one array
                  let users = [];

                  for (let level of this.sortedLevels) {
                    for (let member of level.levelMembers) {
                      users.push({
                        level: level.levelOrder, // remember where we found it
                        member: member // remember its details
                      });
                    }
                  }

                  // find the node and it's parent in the one array
                  let parent = users.find(u => u.member.id == mem.parentId);
                  let child = users.find(u => u.member.id == mem.id);

                  // add a connector, passing in the parent's level, the parent's details, the child's level
                  // and the child's details
                  this.addConnector(
                    { level: parent.levelOrder, member: parent.member },
                    { level: child.levelOrder, member: child.member }
                  );
                }
              }
            }
          }
        }

        // Now remove any connectors previously marked for removal
        for (let rem of removeArray) {
          let idx = this.connectors.findIndex(c => c.id == rem.id);
          if (idx >= 0) this.connectors.splice(idx, 1);
        }

        // And recalculate the positions of all the connectors
        this.recalculateConnectors();
      } catch (e) {
        this.addToErrorLogs("swimlanes-component handleAgentConnectors", e);
      }
    },
    removeConnectors(node) {
      try {
        // Remove all connectors where the given node is parent or child of the connector.
        let rem = [];

        for (let connector of this.connectors) {
          if (
            connector.ele1ref == this.buildRef(node) ||
            connector.ele2ref == this.buildRef(node)
          ) {
            rem.push(connector.id);
          }
        }

        for (let r of rem) {
          let idx = this.connectors.findIndex(c => c.id == r);
          if (idx >= 0) this.connectors.splice(idx, 1);
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-component removeConnectors", e);
      }
    },
    removeParentConnector(node) {
      try {
        let rem = [];

        for (let connector of this.connectors) {
          if (connector.ele2ref == this.buildRef(node)) {
            rem.push(connector.id);
          }
        }

        for (let r of rem) {
          let idx = this.connectors.findIndex(c => c.id == r);
          if (idx >= 0) this.connectors.splice(idx, 1);
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-component removeParentConnector", e);
      }
    },
    recalc() {
      try {
        this.$nextTick(function() {
          this.recalculateConnectors();
        });
        return 0;
      } catch (e) {
        this.addToErrorLogs("swimlanes-component recalc", e);
        return 0;
      }
    },
    dragStart(e) {
      EventBus.$emit("dragStart", e);
    },
    dragEnd(e) {
      EventBus.$emit("dragEnd", e);
    },
    addConnector(parent, child) {
      if (!parent || !child) return;

      if (parent.member && !parent.member.id) return;

      if (child.member && !child.member.id) return;
      if (parent.member.id == child.member.id) return;
      let conn = this.connectors.find(
        c =>
          c.ele1 == this.buildRef(parent.member) &&
          c.ele2 == this.buildRef(child.member)
      );

      if (conn) return;

      try {
        let arrow = {
          id: 0,
          line: undefined,
          ele1: undefined,
          ele2: undefined,
          div: {},
          from: parent.member.name,
          to: child.member.name
        };

        this.InitializeConnector({}, arrow);
        this.connectors.push(arrow);

        this.$nextTick(function() {
          if (parent) {
            this.Connector(
              {
                ele1: this.buildRef(parent.member),
                ele2: this.buildRef(child.member),
                gapY1: 10,
                gapX1: 5,
                gapX2: 5,
                connectorColor: this.connectorColors
                  ? this.connectorColors[parent.level]
                  : "blue"
              },
              arrow
            );
          }
        });
      } catch (e) {
        this.addToErrorLogs("swimlanes-component addConnector", e);
      }
    },
    recalculateConnectors() {
      if (this.bulkMoveInProgress) return;

      try {
        for (let connector of this.connectors) {
          this.link(connector);
        }

        return 0;
      } catch (e) {
        this.addToErrorLogs("swimlanes-component recalculateConnectors", e);
        return 0;
      }
    },
    buildStyle(connector) {
      try {
        if (connector.style == undefined) return "";

        for (let level of this.levels) {
          for (let member of level.levelMembers) {
            if (connector.ele1ref == this.buildRef(member)) {
              connector.color = this.connectorColors[level.levelOrder];
            }
          }
        }

        let top = connector.style.originY + 15; // + connector.style.adj1hp;

        return (
          "left: " +
          connector.style.originX +
          "px;" +
          "height: " +
          connector.style.l +
          "px;" +
          "width: 0px;" +
          "top: " +
          top +
          "px;" +
          "-webkit-transform: " +
          "rotate(" +
          connector.style.angle +
          "deg);" +
          "-moz-transform: " +
          "rotate(" +
          connector.style.angle +
          "deg);" +
          "-o-transform:  " +
          "rotate(" +
          connector.style.angle +
          "deg);" +
          "-ms-transform:  " +
          "rotate(" +
          connector.style.angle +
          "deg);" +
          "transform:  " +
          "rotate(" +
          connector.style.angle +
          "deg);" +
          "transform-origin: '0 " +
          -1 * connector.style.adj1hp +
          "px';" +
          "border-left: 3px dashed " +
          connector.color +
          ";"
        );
      } catch (e) {
        this.addToErrorLogs("swimlanes-component buildStyle", e);
      }
    },
    InitializeConnector(params, connector) {
      try {
        var className = params.class || "muConnector";
        connector.id = this.PseudoGuid(); // use guid to avoid id-clashes with manual code.
        connector.lineID = "L" + connector.id;
        connector.div = {};
        connector.div.lineId = connector.lineID.replace(/-/g, "");
        connector.div.className = className;
        connector.lineStyle = "";
      } catch (e) {
        this.addToErrorLogs("swimlanes-component InitializeConnector", e);
      }
    },

    Connector(params, connector) {
      try {
        if (typeof params == "undefined") {
          return false;
        }

        connector.color = params.connectorColor;

        connector.ele1ref = params.ele1 || "";
        connector.ele2ref = params.ele2 || "";

        connector.ele1 = params.ele1 || ""; // First element to link
        connector.ele2 = params.ele2 || ""; // Second element to link

        if (connector.ele1.length === 0 || connector.ele2.length === 0) {
          return false;
        }

        connector.gapX1 = params.gapX1 || 0; // First element gap before start of connector, etc
        connector.gapY1 = params.gapY1 || 0;
        connector.gapX2 = params.gapX2 || 0;
        connector.gapY2 = params.gapY2 || 0;

        connector.gap = params.gap || 0; // use a single gap setting.
        if (connector.gap > 0) {
          connector.gapX1 = this.gap;
          connector.gapY1 = this.gap;
          connector.gapX2 = this.gap;
          connector.gapY2 = this.gap;
        }

        var pos = function() {
          // only used for standalone drag processing.
          this.left = 0;
          this.top = 0;
        };

        if (
          !this.$refs[connector.ele1] ||
          !this.$refs[connector.ele2] ||
          !this.$refs[connector.div.lineId]
        )
          return;

        connector.ele1 = this.$refs[connector.ele1][0];
        connector.ele2 = this.$refs[connector.ele2][0];

        connector.line = this.$refs[connector.div.lineId][0];

        connector.offsets = [];
        connector.offsets[connector.ele1] = new pos();
        connector.offsets[connector.ele2] = new pos();

        this.link(connector); // show the initial link
      } catch (e) {
        this.addToErrorLogs("swimlanes-component Connector", e);
      }
    },
    link(connector) {
      try {
        if (!this.$refs[connector.ele1ref] || !this.$refs[connector.ele2ref])
          return;

        connector.ele1 = this.$refs[connector.ele1ref][0];
        connector.ele2 = this.$refs[connector.ele2ref][0];

        if (connector.ele1 == undefined || !connector.ele2 == undefined) {
          let idx = this.connectors.findIndex(c => c.ic == connector.id);
          if (idx >= 0) this.connectors.splice(idx, 1);

          return;
        }
        var originX =
          connector.ele1.offsetLeft + connector.ele1.offsetWidth / 2;
        var originY =
          connector.ele1.offsetTop + connector.ele1.offsetHeight / 2;

        var targetX =
          connector.ele2.offsetLeft + connector.ele2.offsetWidth / 2;
        var targetY =
          connector.ele2.offsetTop - connector.ele2.offsetHeight / 2;

        var l = this.hyp(targetX - originX, targetY - originY);

        var angle = (180 / 3.1415) * Math.acos((targetY - originY) / l);
        if (targetX > originX) {
          angle = angle * -1;
        }

        // Compute adjustments to edge of element plus gaps.
        var adj1 = this.edgeAdjust(
          angle,
          connector.gapX1 + connector.ele1.offsetWidth / 2,
          connector.gapY1 + connector.ele1.offsetHeight / 2
        );
        // var adj2 = this.edgeAdjust(
        //   angle,
        //   connector.gapX2 + connector.ele2.offsetWidth / 2,
        //   connector.gapY2 + connector.ele2.offsetHeight / 2
        // );

        // l = l - (adj1.hp + adj2.hp);

        connector.style = {
          originX: originX,
          l: l,
          originY: originY,
          adj1hp: adj1.hp,
          angle: angle
        };

        connector.lineStyle = this.buildStyle(connector);
      } catch (e) {
        this.addToErrorLogs("swimlanes-component link", e);
      }
    },
    Round(value, places) {
      try {
        var multiplier = Math.pow(10, places);
        return Math.round(value * multiplier) / multiplier;
      } catch (e) {
        this.addToErrorLogs("swimlanes-component Round", e);
        return value;
      }
    },
    edgeAdjust(a, w1, h1) {
      try {
        var w = 0,
          h = 0;

        // compute corner angles
        var ca = [];
        ca[0] = (Math.atan(w1 / h1) * 180) / 3.1415926; // RADIANS !!!
        ca[1] = 180 - ca[0];
        ca[2] = ca[0] + 180;
        ca[3] = ca[1] + 180;

        // Based on the possible sector and angle combinations work out the adjustments.
        if (this.Round(a, 0) === 0) {
          h = h1;
          w = 0;
        } else if (this.Round(a, 0) === 180) {
          h = h1;
          w = 0;
        } else if ((a > 0 && a <= ca[0]) || (a < 0 && a >= -1 * ca[0])) {
          h = h1;
          w = -1 * Math.tan(a * (3.1415926 / 180)) * h1;
        } else if (a > ca[0] && a <= 90) {
          h = Math.tan((90 - a) * (3.1415926 / 180)) * w1;
          w = w1;
        } else if (a > 90 && a <= ca[1]) {
          h = -1 * Math.tan((a - 90) * (3.1415926 / 180)) * w1;
          w = w1;
        } else if (a > ca[1] && a <= 180) {
          h = h1;
          w = -1 * Math.tan((180 - a) * (3.1415926 / 180)) * h1;
        } else if (a > -180 && a <= -1 * ca[1]) {
          h = h1;
          w = Math.tan((a - 180) * (3.1415926 / 180)) * h1;
        } else if (a > -1 * ca[1] && a <= 0) {
          h = Math.tan((a - 90) * (3.1415926 / 180)) * w1;
          w = w1;
        }

        // We now have the width and height offsets - compute the hypotenuse.
        var hp = this.hyp(w, h);

        return { hp: hp };
      } catch (e) {
        this.addToErrorLogs("swimlanes-component edgeAdjust", e);
        return { hp: 0 };
      }
    },
    hyp(X, Y) {
      try {
        return Math.abs(Math.sqrt(X * X + Y * Y));
      } catch (e) {
        this.addToErrorLogs("swimlanes-component hyp", e);
        return 0;
      }
    },
    moved(e, ele, connector) {
      try {
        connector.id = ele.attr("id");
        this.link(connector);
      } catch (e) {
        this.addToErrorLogs("swimlanes-component moved", e);
      }
    }
  }
};
</script>
<style>
.highlight {
  background-color: greenyellow;
}
</style>

<style scoped>
.hierCol {
  overflow: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 0px;
  margin-top: 0px;
  min-width: 100%;
  max-height: 80%;
  min-height: 0px;
}

.agentWrapper {
  flex-wrap: nowrap !important;
}

.hierRow {
  padding-top: 35px;
  padding-bottom: 35px;
  padding-left: 10px;
}
.thing {
  min-width: 245px;
  height: 2.1rem;
  padding: 0px;
  margin: 0px;
  background: transparent;
  font-size: 0.9rem;
}

.muConnector {
  position: absolute;
  border-left: 3px dashed green;
  z-index: 100;
  -webkit-transform-origin: top left;
  -moz-transform-origin: top left;
  -o-transform-origin: top left;
  -ms-transform-origin: top left;
  transform-origin: top left;
}

.nameDiv {
  /* border: 2px solid steelblue !important; */
  border-radius: 5px;
  text-align: center;

  background-color: white;
  z-index: 195;
}
.v-overlay {
  align-items: flex-start !important;
  justify-content: flex-start !important;
  color: rgb(185, 209, 230);
}
.drag-item-text {
  font-size: 0.95rem;
  padding-left: 1rem;
}
.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 1.5rem;
  max-height: 2.1rem;
}
.v-list-item {
  padding: 0;
}
.theme--light.v-list-item--active:before,
.theme--light.v-list-item--active:hover:before,
.theme--light.v-list-item:focus:before {
  min-width: 100px !important;
}
</style>
<style lang="scss">
$ease-out: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
.drag-item {
  flex-wrap: nowrap;
  transition: $ease-out;
  cursor: pointer;
  height: 2rem;

  /* items grabbed state */
  &[aria-grabbed="true"] {
    background: #b3d4fc;
    color: rgb(0, 85, 140);
    height: 2rem;
    margin-top: -2px;
    outline: none !important;
  }
}
</style>
